export default __webpack_public_path__ + "static/media/simplicity-logo.d17288a7.svg";